import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Recepciones emitidas
    recadvsEmit: {
      tableData: [],
      totalRecadvsEmit: 0
    },
    queryRecadvsEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersRecadvsEmit: [],

    // Recepciones Recibidas
    recadvsReceived: {
      tableData: [],
      totalRecadvsReceived: 0
    },
    queryRecadvsReceived: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersRecadvsReceived: [],
    // Combo estados recepciones
    optionsFilterStatusRecadv: [],

    // Datos Select Filtros Recepciones Emitidas
    optionsFilterBuyerRecadvEmit: [],
    optionsFilterSellerRecadvEmit: [],
    optionsFilterNumRecadvEmit: [],
    optionsFilterDateReceivingRecadvEmit: [],
    optionsFilterDateDeliveryRecadvEmit: [],
    optionsFilterDateCreationRecadvEmit: [],
    optionsFilterOrderNumberRecadvEmit: [],
    optionsFilterInvoiceNumberRecadvEmit: [],
    // Datos Select Filtros Recepciones recibidas
    optionsFilterBuyerRecadvReceived: [],
    optionsFilterSellerRecadvReceived: [],
    optionsFilterNumRecadvReceived: [],
    optionsFilterDateReceivingRecadvReceived: [],
    optionsFilterDateDeliveryRecadvReceived: [],
    optionsFilterDateCreationRecadvReceived: [],
    optionsFilterOrderNumberRecadvReceived: [],
    optionsFilterInvoiceNumberRecadvReceived: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Recepciones Emitidas
    isShowBuyerRecadvEmit: true,
    isShowSellerRecadvEmit: true,
    isShowNumRecadvEmit: true,
    isShowDateReceivingRecadvEmit: true,
    isShowDateCreationRecadvEmit: true,
    isShowStatusRecadvEmit: true,
    isShowServiceRecadvEmit: true,
    isShowInvoiceRecadvEmit: true,
    isShowCentroVendedorRecadvEmit: false,
    isShowCentroCompradorRecadvEmit: false,
    isShowCentroEntregaRecadvEmit: false,


    // Columnas Tabla Recepciones recibidas
    isShowBuyerRecadvReceived: true,
    isShowSellerRecadvReceived: true,
    isShowNumRecadvReceived: true,
    isShowDateReceivingRecadvReceived: true,
    isShowDateCreationRecadvReceived: true,
    isShowStatusRecadvReceived: true,
    isShowServiceRecadvReceived: true,
    isShowInvoiceRecadvReceived: true,
    isShowCentroVendedorRecadvReceived: false,
    isShowCentroCompradorRecadvReceived: false,
    isShowCentroEntregaRecadvReceived: false,

    // Columnas Tabla lineas emitidas
    isShowCodeLinesEmit: true,
    isShowItemCodeSellerRecadvLinesEmit: false,
    isShowItemCodeBuyerRecadvLinesEmit: false,
    isShowDescriptionRecadvLinesEmit: false,
    isShowOrderLinesEmit: true,
    isShowDeliveryNoteNumberRecadvLinesEmit: false,
    isShowDeliveryNoteLineRecadvLinesEmit: false,
    isShowDespatchQuantityLinesEmit: true,
    isShowReceivedQuantityLinesEmit: true,
    isShowAcceptedQuantityLinesEmit: true,
    isShowMeasureRecadvLinesEmit: true,
    isShowPriceLinesEmit: true,
    isShowCurrencyRecadvLinesEmit: true,
    isShowStatusRecadvLinesEmit: true,
    isShowSubtypeRecadvLinesEmit: true,

    // Columnas Tabla lineas recibidas
    isShowCodeLinesReceived: true,
    isShowItemCodeSellerRecadvLinesReceived: false,
    isShowItemCodeBuyerRecadvLinesReceived: false,
    isShowDescriptionRecadvLinesReceived: false,
    isShowOrderLinesReceived: true,
    isShowDeliveryNoteNumberRecadvLinesReceived: false,
    isShowDeliveryNoteLineRecadvLinesReceived: false,
    isShowDespatchQuantityLinesReceived: true,
    isShowReceivedQuantityLinesReceived: true,
    isShowAcceptedQuantityLinesReceived: true,
    isShowMeasureRecadvLinesReceived: true,
    isShowPriceLinesReceived: true,
    isShowCurrencyRecadvLinesReceived: true,
    isShowStatusRecadvLinesReceived: true,
    isShowSubtypeRecadvLinesReceived: true,

  }
  return local
}
function setByUserLocalRecadv () {
  const local = {
    // Columnas Tabla Recepciones Emitidas
    isShowBuyerRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowBuyerRecadvEmit,
    isShowSellerRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowSellerRecadvEmit,
    isShowNumRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowNumRecadvEmit,
    isShowDateReceivingRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDateReceivingRecadvEmit,
    isShowDateCreationRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDateCreationRecadvEmit,
    isShowStatusRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowStatusRecadvEmit,
    isShowServiceRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowServiceRecadvEmit,
    isShowInvoiceRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowInvoiceRecadvEmit,
    isShowCentroVendedorRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroVendedorRecadvEmit,
    isShowCentroCompradorRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroCompradorRecadvEmit,
    isShowCentroEntregaRecadvEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroEntregaRecadvEmit,

    // Columnas Tabla Recepciones recibidas
    isShowBuyerRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowBuyerRecadvReceived,
    isShowSellerRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowSellerRecadvReceived,
    isShowNumRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowNumRecadvReceived,
    isShowDateReceivingRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDateReceivingRecadvReceived,
    isShowDateCreationRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDateCreationRecadvReceived,
    isShowStatusRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowStatusRecadvReceived,
    isShowServiceRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowServiceRecadvReceived,
    isShowInvoiceRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowInvoiceRecadvReceived,
    isShowCentroVendedorRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroVendedorRecadvReceived,
    isShowCentroCompradorRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroCompradorRecadvReceived,
    isShowCentroEntregaRecadvReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCentroEntregaRecadvReceived,

    
    // Columnas tabla lineas emitidas
    isShowCodeLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCodeLinesEmit,
    isShowItemCodeSellerRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowItemCodeSellerRecadvLinesEmit,
    isShowItemCodeBuyerRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowItemCodeBuyerRecadvLinesEmit,
    isShowDescriptionRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDescriptionRecadvLinesEmit,
    isShowOrderLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowOrderLinesEmit,
    isShowDeliveryNoteNumberRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDeliveryNoteNumberRecadvLinesEmit,
    isShowDeliveryNoteLineRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDeliveryNoteLineRecadvLinesEmit,
    isShowDespatchQuantityLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDespatchQuantityLinesEmit,
    isShowReceivedQuantityLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowReceivedQuantityLinesEmit,
    isShowAcceptedQuantityLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowAcceptedQuantityLinesEmit,
    isShowMeasureRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowMeasureRecadvLinesEmit,
    isShowPriceLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowPriceLinesEmit,
    isShowCurrencyRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCurrencyRecadvLinesEmit,
    isShowStatusRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowStatusRecadvLinesEmit,
    isShowSubtypeRecadvLinesEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowSubtypeRecadvLinesEmit,
    
    // Columnas tabla lineas recibidas
    isShowCodeLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCodeLinesReceived,
    isShowItemCodeSellerRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowItemCodeSellerRecadvLinesReceived,
    isShowItemCodeBuyerRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowItemCodeBuyerRecadvLinesReceived,
    isShowDescriptionRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDescriptionRecadvLinesReceived,
    isShowOrderLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowOrderLinesReceived,
    isShowDeliveryNoteNumberRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDeliveryNoteNumberRecadvLinesReceived,
    isShowDeliveryNoteLineRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDeliveryNoteLineRecadvLinesReceived,
    isShowDespatchQuantityLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowDespatchQuantityLinesReceived,
    isShowReceivedQuantityLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowReceivedQuantityLinesReceived,
    isShowAcceptedQuantityLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowAcceptedQuantityLinesReceived,
    isShowMeasureRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowMeasureRecadvLinesReceived,
    isShowPriceLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowPriceLinesReceived,
    isShowCurrencyRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowCurrencyRecadvLinesReceived,
    isShowStatusRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowStatusRecadvLinesReceived,
    isShowSubtypeRecadvLinesReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).recepciones.isShowSubtypeRecadvLinesReceived,
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla Recepciones Emitidas
    isShowBuyerRecadvEmit: true,
    isShowSellerRecadvEmit: true,
    isShowNumRecadvEmit: true,
    isShowDateReceivingRecadvEmit: true,
    isShowDateCreationRecadvEmit: true,
    isShowStatusRecadvEmit: true,
    isShowServiceRecadvEmit: true,
    isShowInvoiceRecadvEmit: true,
    isShowCentroVendedorRecadvEmit: false,
    isShowCentroCompradorRecadvEmit: false,
    isShowCentroEntregaRecadvEmit: false,

    // Columnas Tabla Recepciones recibidas
    isShowBuyerRecadvReceived: true,
    isShowSellerRecadvReceived: true,
    isShowNumRecadvReceived: true,
    isShowDateReceivingRecadvReceived: true,
    isShowDateCreationRecadvReceived: true,
    isShowStatusRecadvReceived: true,
    isShowServiceRecadvReceived: true,
    isShowInvoiceRecadvReceived: true,
    isShowCentroVendedorRecadvReceived: false,
    isShowCentroCompradorRecadvReceived: false,
    isShowCentroEntregaRecadvReceived: false,

    // Columnas Tabla lineas emitidas
    isShowCodeLinesEmit: true,
    isShowItemCodeSellerRecadvLinesEmit: false,
    isShowItemCodeBuyerRecadvLinesEmit: false,
    isShowDescriptionRecadvLinesEmit: false,
    isShowOrderLinesEmit: true,
    isShowDeliveryNoteNumberRecadvLinesEmit: false,
    isShowDeliveryNoteLineRecadvLinesEmit: false,
    isShowDespatchQuantityLinesEmit: true,
    isShowReceivedQuantityLinesEmit: true,
    isShowAcceptedQuantityLinesEmit: true,
    isShowMeasureRecadvLinesEmit: true,
    isShowPriceLinesEmit: true,
    isShowCurrencyRecadvLinesEmit: true,
    isShowStatusRecadvLinesEmit: true,
    isShowSubtypeRecadvLinesEmit: true,

    // Columnas Tabla lineas recibidas
    isShowCodeLinesReceived: true,
    isShowItemCodeSellerRecadvLinesReceived: false,
    isShowItemCodeBuyerRecadvLinesReceived: false,
    isShowDescriptionRecadvLinesReceived: false,
    isShowOrderLinesReceived: true,
    isShowDeliveryNoteNumberRecadvLinesReceived: false,
    isShowDeliveryNoteLineRecadvLinesReceived: false,
    isShowDespatchQuantityLinesReceived: true,
    isShowReceivedQuantityLinesReceived: true,
    isShowAcceptedQuantityLinesReceived: true,
    isShowMeasureRecadvLinesReceived: true,
    isShowPriceLinesReceived: true,
    isShowCurrencyRecadvLinesReceived: true,
    isShowStatusRecadvLinesReceived: true,
    isShowSubtypeRecadvLinesReceived: true,
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Recepciones Emitidas
  recadvsEmit: state => {
    return state.session.recadvsEmit
  },
  queryRecadvsEmit: state => {
    return state.session.queryRecadvsEmit
  },
  listSelectedFiltersRecadvsEmit: state => {
    return state.session.listSelectedFiltersRecadvsEmit
  },

  // Datos Tabla Recepciones Recibidas
  recadvsReceived: state => {
    return state.session.recadvsReceived
  },
  queryRecadvsReceived: state => {
    return state.session.queryRecadvsReceived
  },
  listSelectedFiltersRecadvsReceived: state => {
    return state.session.listSelectedFiltersRecadvsReceived
  },

  // Datos Select Filtros Recepciones Emitidas
  optionsFilterBuyerRecadvEmit: state => {
    return state.session.optionsFilterBuyerRecadvEmit
  },
  optionsFilterSellerRecadvEmit: state => {
    return state.session.optionsFilterSellerRecadvEmit
  },
  optionsFilterNumRecadvEmit: state => {
    return state.session.optionsFilterNumRecadvEmit
  },
  optionsFilterDateReceivingRecadvEmit: state => {
    return state.session.optionsFilterDateReceivingRecadvEmit
  },
  optionsFilterDateDeliveryRecadvEmit: state => {
    return state.session.optionsFilterDateDeliveryRecadvEmit
  },
  optionsFilterDateCreationRecadvEmit: state => {
    return state.session.optionsFilterDateCreationRecadvEmit
  },
  optionsFilterOrderNumberRecadvEmit: state => {
    return state.session.optionsFilterOrderNumberRecadvEmit
  },
  optionsFilterInvoiceNumberRecadvEmit: state => {
    return state.session.optionsFilterInvoiceNumberRecadvEmit
  },

  // Datos Select Filtros Recepciones Recibidas
  optionsFilterBuyerRecadvReceived: state => {
    return state.session.optionsFilterBuyerRecadvReceived
  },
  optionsFilterSellerRecadvReceived: state => {
    return state.session.optionsFilterSellerRecadvReceived
  },
  optionsFilterNumRecadvReceived: state => {
    return state.session.optionsFilterNumRecadvReceived
  },
  optionsFilterDateReceivingRecadvReceived: state => {
    return state.session.optionsFilterDateReceivingRecadvReceived
  },
  optionsFilterDateDeliveryRecadvReceived: state => {
    return state.session.optionsFilterDateDeliveryRecadvReceived
  },
  optionsFilterDateCreationRecadvReceived: state => {
    return state.session.optionsFilterDateCreationRecadvReceived
  },
  optionsFilterOrderNumberRecadvReceived: state => {
    return state.session.optionsFilterOrderNumberRecadvReceived
  },
  optionsFilterInvoiceNumberRecadvReceived: state => {
    return state.session.optionsFilterInvoiceNumberRecadvReceived
  },

  // Combo estados
  optionsFilterStatusRecadv: state => {
    return state.session.optionsFilterStatusRecadv
  },

  // Columnas Tabla Recepciones Emitidas
  isShowBuyerRecadvEmit: state => {
    return state.local.isShowBuyerRecadvEmit
  },
  isShowSellerRecadvEmit: state => {
    return state.local.isShowSellerRecadvEmit
  },
  isShowNumRecadvEmit: state => {
    return state.local.isShowNumRecadvEmit
  },
  isShowDateReceivingRecadvEmit: state => {
    return state.local.isShowDateReceivingRecadvEmit
  },
  isShowDateCreationRecadvEmit: state => {
    return state.local.isShowDateCreationRecadvEmit
  },
  isShowStatusRecadvEmit: state => {
    return state.local.isShowStatusRecadvEmit
  },
  isShowServiceRecadvEmit: state => {
    return state.local.isShowServiceRecadvEmit
  },
  isShowInvoiceRecadvEmit: state => {
    return state.local.isShowInvoiceRecadvEmit
  },
  isShowCentroVendedorRecadvEmit: state => {
    return state.local.isShowCentroVendedorRecadvEmit
  },
  isShowCentroCompradorRecadvEmit: state => {
    return state.local.isShowCentroCompradorRecadvEmit
  },
  isShowCentroEntregaRecadvEmit: state => {
    return state.local.isShowCentroEntregaRecadvEmit
  },

  // Columnas Tabla Recepciones Recibidas
  isShowBuyerRecadvReceived: state => {
    return state.local.isShowBuyerRecadvReceived
  },
  isShowSellerRecadvReceived: state => {
    return state.local.isShowSellerRecadvReceived
  },
  isShowNumRecadvReceived: state => {
    return state.local.isShowNumRecadvReceived
  },
  isShowDateReceivingRecadvReceived: state => {
    return state.local.isShowDateReceivingRecadvReceived
  },
  isShowDateCreationRecadvReceived: state => {
    return state.local.isShowDateCreationRecadvReceived
  },
  isShowStatusRecadvReceived: state => {
    return state.local.isShowStatusRecadvReceived
  },
  isShowServiceRecadvReceived: state => {
    return state.local.isShowServiceRecadvReceived
  },
  isShowInvoiceRecadvReceived: state => {
    return state.local.isShowInvoiceRecadvReceived
  },
  isShowCentroVendedorRecadvReceived: state => {
    return state.local.isShowCentroVendedorRecadvReceived
  },
  isShowCentroCompradorRecadvReceived: state => {
    return state.local.isShowCentroCompradorRecadvReceived
  },
  isShowCentroEntregaRecadvReceived: state => {
    return state.local.isShowCentroEntregaRecadvReceived
  },
  // Columnas lineas Recepciones emitidas
  isShowCodeLinesEmit: state => {
    return state.local.isShowCodeLinesEmit
  },
  isShowItemCodeSellerRecadvLinesEmit: state => {
    return state.local.isShowItemCodeSellerRecadvLinesEmit
  },
  isShowItemCodeBuyerRecadvLinesEmit: state => {
    return state.local.isShowItemCodeBuyerRecadvLinesEmit
  },
  isShowDescriptionRecadvLinesEmit: state => {
    return state.local.isShowDescriptionRecadvLinesEmit
  },
  isShowOrderLinesEmit: state => {
    return state.local.isShowOrderLinesEmit
  },
  isShowDeliveryNoteNumberRecadvLinesEmit: state => {
    return state.local.isShowDeliveryNoteNumberRecadvLinesEmit
  },
  isShowDeliveryNoteLineRecadvLinesEmit: state => {
    return state.local.isShowDeliveryNoteLineRecadvLinesEmit
  },
  isShowDespatchQuantityLinesEmit: state => {
    return state.local.isShowDespatchQuantityLinesEmit
  },
  isShowReceivedQuantityLinesEmit: state => {
    return state.local.isShowReceivedQuantityLinesEmit
  },
  isShowAcceptedQuantityLinesEmit: state => {
    return state.local.isShowAcceptedQuantityLinesEmit
  },
  isShowMeasureRecadvLinesEmit: state => {
    return state.local.isShowMeasureRecadvLinesEmit
  },
  isShowPriceLinesEmit: state => {
    return state.local.isShowPriceLinesEmit
  },
  isShowCurrencyRecadvLinesEmit: state => {
    return state.local.isShowCurrencyRecadvLinesEmit
  },
  isShowStatusRecadvLinesEmit: state => {
    return state.local.isShowStatusRecadvLinesEmit
  },
  isShowSubtypeRecadvLinesEmit: state => {
    return state.local.isShowSubtypeRecadvLinesEmit
  },
  // Columnas lineas Recepciones recibidas
  isShowCodeLinesReceived: state => {
    return state.local.isShowCodeLinesReceived
  },
  isShowItemCodeSellerRecadvLinesReceived: state => {
    return state.local.isShowItemCodeSellerRecadvLinesReceived
  },
  isShowItemCodeBuyerRecadvLinesReceived: state => {
    return state.local.isShowItemCodeBuyerRecadvLinesReceived
  },
  isShowDescriptionRecadvLinesReceived: state => {
    return state.local.isShowDescriptionRecadvLinesReceived
  },
  isShowOrderLinesReceived: state => {
    return state.local.isShowOrderLinesReceived
  },
  isShowDeliveryNoteNumberRecadvLinesReceived: state => {
    return state.local.isShowDeliveryNoteNumberRecadvLinesReceived
  },
  isShowDeliveryNoteLineRecadvLinesReceived: state => {
    return state.local.isShowDeliveryNoteLineRecadvLinesReceived
  },
  isShowDespatchQuantityLinesReceived: state => {
    return state.local.isShowDespatchQuantityLinesReceived
  },
  isShowReceivedQuantityLinesReceived: state => {
    return state.local.isShowReceivedQuantityLinesReceived
  },
  isShowAcceptedQuantityLinesReceived: state => {
    return state.local.isShowAcceptedQuantityLinesReceived
  },
  isShowMeasureRecadvLinesReceived: state => {
    return state.local.isShowMeasureRecadvLinesReceived
  },
  isShowPriceLinesReceived: state => {
    return state.local.isShowPriceLinesReceived
  },
  isShowCurrencyRecadvLinesReceived: state => {
    return state.local.isShowCurrencyRecadvLinesReceived
  },
  isShowStatusRecadvLinesReceived: state => {
    return state.local.isShowStatusRecadvLinesReceived
  },
  isShowSubtypeRecadvLinesReceived: state => {
    return state.local.isShowSubtypeRecadvLinesReceived
  }
}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameRecadv ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalRecadv()
    }
  },
  async isNewVersionRecepcionesLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.recepciones)
    return isnew
  },

  /* RECEPCIONES */
  /**
  * Servicio para traer las recepciones emitidas y recibidas .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getRecadvs ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/recadv',
		    baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('RECADVS_EMIT_STATE', {
        tableData: response.data.content,
        totalRecadvsEmit: response.data.totalElements
      })

      commit('RECADVS_RECEIVED_STATE', {
        tableData: response.data.content,
        totalRecadvsReceived: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de una recepción
  async getRecadvDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/recadv/' + params.recadvID,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   // Servicio de modificacion de una recepción
   async modifyRecadv ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/recadv/' + data.recadvId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.dataQuery.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      console.log('return: ', response)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de estados de las recepciones emitidas y recibidas
   */
  async getOptionsFilterStatusRecadv ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/recadvstatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterStatusRecadv = response.data
      commit('OPTIONS_FILTER_STATUS_RECADVS', optionsFilterStatusRecadv)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusRecadv
    } catch (error) {
      console.log('status recadv : ', error)
      throw error.response
    }
  },

  /**
   * Servicio para obtener las lineas de una recpción emitida o recibida
   */
  async getRecadvLines ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/recadv/' + data.query.recadvId + '/lines',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los documentos relacionados de una recepción emitida o recibida
   */
  async getRelatedDocumentsRecadv ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/recadv/' + data.query.recadvId + '/relatedDocuments',
        params: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para rechazar una recepción
  */
  async rejectedRecadv ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/recadv/' + request.recadvId + '/rejected/',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          motive: request.motive,
          searchType: request.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para dar de alta Nueva / Edit linea de recepción
  */
  async newLineRecadv ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/recadv/' + request.recadvId + '/newLine/',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          description: request.description,
          quantity: request.quantity,
          priceUnit: request.priceUnit,
          measure: request.measure,
          idRecadvLine: request.idRecadvLine,
          searchType: request.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
  * Servicio para activar una recepción
  */
  async activateRecadv ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/recadv/' + request.recadvId + '/activate/',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: request.searchType
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async downloadRecadvOriginal ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/recadv/' + params.recadvsId + '/original',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'recepciones-original'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async downloadRecadvMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/recadv/' + params.recadvsId + '/metadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'recepciones-metadata'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar ZIP de todos los PDF de Recepciones
     * @param {*} recadvsIds
     */
  async downloadRecadvPdfMultiple ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/recadv/pdf',
        params: {
          recadvId: params.recadvsIds,
          searchType: params.searchType
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'pdfs-recadv.zip'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para Exportar Todas las Recepciones  a CSV
     */
  async downloadCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/recadv/csv',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'recadvs.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para comprobar si activar la creación de factura
     * de la lista de recepcionse
     * @param {*} recadvsIds
     */
  async validaCreateInvoiceFromList ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/recadv/validacreateinvoice',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          recadvId: params.recadvsIds,
          searchType: params.searchType
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Recepciones Emitidas
  recadvsEmitState: ({ commit }, payload) => {
    commit('RECADVS_EMIT_STATE', payload)
  },
  queryRecadvsEmitState: ({ commit }, payload) => {
    commit('QUERY_RECADVS_EMIT_STATE', payload)
  },
  listSelectedFiltersRecadvsEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_RECADVS_EMIT_STATE', payload)
  },

  // Datos Tabla Recepciones Recibidas
  recadvsReceivedState: ({ commit }, payload) => {
    commit('RECADVS_RECEIVED_STATE', payload)
  },
  queryRecadvsReceivedState: ({ commit }, payload) => {
    commit('QUERY_RECADVS_RECEIVED_STATE', payload)
  },
  listSelectedFiltersRecadvsReceivedState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_RECADVS_RECEIVED_STATE', payload)
  },

  // Datos Select Filtros Recepciones Emitidas
  optionsFilterBuyerRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_RECADVS_EMIT', payload)
  },
  optionsFilterSellerRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_RECADVS_EMIT', payload)
  },
  optionsFilterNumRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_NUM_RECADVS_EMIT', payload)
  },
  optionsFilterDateReceivingRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_RECEIVING_RECADVS_EMIT', payload)
  },
  optionsFilterDateDeliveryRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_DELIVERY_RECADVS_EMIT', payload)
  },
  optionsFilterDateCreationRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_RECADVS_EMIT', payload)
  },
  optionsFilterOrderNumberRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ORDER_NUMBER_RECADVS_EMIT', payload)
  },
  optionsFilterInvoiceNumberRecadvEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_NUMBER_RECADVS_EMIT', payload)
  },

  // Datos Select Filtros Recepciones Recibidas
  optionsFilterBuyerRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_RECADVS_RECEIVED', payload)
  },
  optionsFilterSellerRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_RECADVS_RECEIVED', payload)
  },
  optionsFilterNumRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_NUM_RECADVS_RECEIVED', payload)
  },
  optionsFilterDateReceivingRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_RECEIVING_RECADVS_RECEIVED', payload)
  },
  optionsFilterDateDeliveryRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_DELIVERY_RECADVS_RECEIVED', payload)
  },
  optionsFilterDateCreationRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_RECADVS_RECEIVED', payload)
  },
  optionsFilterOrderNumberRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_ORDER_NUMBER_RECADVS_RECEIVED', payload)
  },
  optionsFilterInvoiceNumberRecadvReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_NUMBER_RECADVS_RECEIVED', payload)
  },

  // Combo estados
  optionsFilterStatusRecadvState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_RECADVS', payload)
  },

  // Columnas Tabla Recepciones Emitidas
  isShowBuyerRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_RECADV_EMIT', payload)
  },
  isShowSellerRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_RECADV_EMIT', payload)
  },
  isShowNumRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_RECADV_EMIT', payload)
  },
  isShowDateReceivingRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_RECEIVING_RECADV_EMIT', payload)
  },
  isShowDateCreationRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_RECADV_EMIT', payload)
  },
  isShowStatusRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_RECADV_EMIT', payload)
  },
  isShowServiceRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_RECADV_EMIT', payload)
  },
  isShowInvoiceRecadvEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_INVOICE_RECADV_EMIT', payload)
  },
  isShowCentroVendedorRecadvEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_RECADV_EMIT', payload)
  },
  isShowCentroCompradorRecadvEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_RECADV_EMIT', payload)
  },
  isShowCentroEntregaRecadvEmitAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_RECADV_EMIT', payload)
  },  

  // Columnas Tabla Recepciones Recibidas
  isShowBuyerRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_RECADV_RECEIVED', payload)
  },
  isShowSellerRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_RECADV_RECEIVED', payload)
  },
  isShowNumRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_RECADV_RECEIVED', payload)
  },
  isShowDateReceivingRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_RECEIVING_RECADV_RECEIVED', payload)
  },
  isShowDateCreationRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_RECADV_RECEIVED', payload)
  },
  isShowStatusRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_RECADV_RECEIVED', payload)
  },
  isShowServiceRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_RECADV_RECEIVED', payload)
  },
  isShowInvoiceRecadvReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_INVOICE_RECADV_RECEIVED', payload)
  },
  isShowCentroVendedorRecadvReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_VENDEDOR_RECADV_RECEIVED', payload)
  },
  isShowCentroCompradorRecadvReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_COMPRADOR_RECADV_RECEIVED', payload)
  },
  isShowCentroEntregaRecadvReceivedAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTRO_ENTREGA_RECADV_RECEIVED', payload)
  },
  // Columnas lineas emitidas
  isShowCodeLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_RECADV_LINES_EMIT', payload)
  },
  isShowItemCodeSellerRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEM_CODE_SELLER_RECADV_LINES_EMIT', payload)
  },
  isShowItemCodeBuyerRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEM_CODE_BUYER_RECADV_LINES_EMIT', payload)
  },
  isShowDescriptionRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_RECADV_LINES_EMIT', payload)
  },
  isShowOrderLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_RECADV_LINES_EMIT', payload)
  },
  isShowDeliveryNoteNumberRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERY_NOTE_NUMBER_RECADV_LINES_EMIT', payload)
  },
  isShowDeliveryNoteLineRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERY_NOTE_LINE_RECADV_LINES_EMIT', payload)
  },
  isShowDespatchQuantityLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESPATCH_QUANTITY_RECADV_LINES_EMIT', payload)
  },
  isShowReceivedQuantityLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVED_QUANTITY_RECADV_LINES_EMIT', payload)
  },
  isShowAcceptedQuantityLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ACCEPTED_QUANTITY_RECADV_LINES_EMIT', payload)
  },
  isShowMeasureRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_RECADV_LINES_EMIT', payload)
  },
  isShowPriceLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_PRICE_RECADV_LINES_EMIT', payload)
  },
  isShowCurrencyRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CURRENCY_RECADV_LINES_EMIT', payload)
  },
  isShowStatusRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_RECADV_LINES_EMIT', payload)
  },
  isShowSubtypeRecadvLinesEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SUBTYPE_RECADV_LINES_EMIT', payload)
  },
  // Columnas lineas recibidas
  isShowCodeLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_RECADV_LINES_RECEIVED', payload)
  },
  isShowItemCodeSellerRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEM_CODE_SELLER_RECADV_LINES_RECEIVED', payload)
  },
  isShowItemCodeBuyerRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEM_CODE_BUYER_RECADV_LINES_RECEIVED', payload)
  },
  isShowDescriptionRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_RECADV_LINES_RECEIVED', payload)
  },
  isShowOrderLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_RECADV_LINES_RECEIVED', payload)
  },
  isShowDeliveryNoteNumberRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERY_NOTE_NUMBER_RECADV_LINES_RECEIVED', payload)
  },
  isShowDeliveryNoteLineRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DELIVERY_NOTE_LINE_RECADV_LINES_RECEIVED', payload)
  },
  isShowDespatchQuantityLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESPATCH_QUANTITY_RECADV_LINES_RECEIVED', payload)
  },
  isShowReceivedQuantityLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVED_QUANTITY_RECADV_LINES_RECEIVED', payload)
  },
  isShowAcceptedQuantityLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_ACCEPTED_QUANTITY_RECADV_LINES_RECEIVED', payload)
  },
  isShowMeasureRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_MEASURE_RECADV_LINES_RECEIVED', payload)
  },
  isShowPriceLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_PRICE_RECADV_LINES_RECEIVED', payload)
  },
  isShowCurrencyRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_CURRENCY_RECADV_LINES_RECEIVED', payload)
  },
  isShowStatusRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_RECADV_LINES_RECEIVED', payload)
  },
  isShowSubtypeRecadvLinesReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SUBTYPE_RECADV_LINES_RECEIVED', payload)
  }
}

// mutations
const mutations = {
  resetSessionRecepciones (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  recadvDatesSuperAdmin (state) {
    state.session.queryRecadvsEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryRecadvsReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Recepciones emitidas
  'RECADVS_EMIT_STATE' (state, payload) {
    state.session.recadvsEmit = payload
  },
  'QUERY_RECADVS_EMIT_STATE' (state, payload) {
    state.session.queryRecadvsEmit = payload
  },
  'LIST_SELECTED_FILTERS_RECADVS_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersRecadvsEmit = payload
  },

  // Recepciones Recibidas
  'RECADVS_RECEIVED_STATE' (state, payload) {
    state.session.recadvsReceived = payload
  },
  'QUERY_RECADVS_RECEIVED_STATE' (state, payload) {
    state.session.queryRecadvsReceived = payload
  },
  'LIST_SELECTED_FILTERS_RECADVS_RECEIVED_STATE' (state, payload) {
    state.session.listSelectedFiltersRecadvsReceived = payload
  },

  // Datos Select Filtros Recepciones  Emitidas
  'OPTIONS_FILTER_BUYER_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterBuyerRecadvEmit = payload
  },
  'OPTIONS_FILTER_SELLER_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterSellerRecadvEmit = payload
  },
  'OPTIONS_FILTER_NUM_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterNumRecadvEmit = payload
  },
  'OPTIONS_FILTER_DATE_RECEIVING_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterDateReceivingRecadvEmit = payload
  },
  'OPTIONS_FILTER_DATE_DELIVERY_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterDateDeliveryRecadvEmit = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationRecadvEmit = payload
  },
  'OPTIONS_FILTER_ORDER_NUMBER_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterOrderNumberRecadvEmit = payload
  },
  'OPTIONS_FILTER_INVOICE_NUMBER_RECADVS_EMIT' (state, payload) {
    state.session.optionsFilterInvoiceNumberRecadvEmit = payload
  },

  // Datos Select Filtros Recepciones Recibidas
  'OPTIONS_FILTER_BUYER_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterBuyerRecadvReceived = payload
  },
  'OPTIONS_FILTER_SELLER_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterSellerRecadvReceived = payload
  },
  'OPTIONS_FILTER_NUM_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterNumRecadvReceived = payload
  },
  'OPTIONS_FILTER_DATE_RECEIVING_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateReceivingRecadvReceived = payload
  },
  'OPTIONS_FILTER_DATE_DELIVERY_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateDeliveryRecadvReceived = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateCreationRecadvReceived = payload
  },
  'OPTIONS_FILTER_ORDER_NUMBER_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterOrderNumberRecadvReceived = payload
  },
  'OPTIONS_FILTER_INVOICE_NUMBER_RECADVS_RECEIVED' (state, payload) {
    state.session.optionsFilterInvoiceNumberRecadvReceived = payload
  },

  // Combo estados recepciones emitidas y recibidas
  'OPTIONS_FILTER_STATUS_RECADVS' (state, payload) {
    state.session.optionsFilterStatusRecadv = payload
  },

  // Columnas Tabla Recepciones Emitidas
  'IS_SHOW_BUYER_RECADV_EMIT' (state, payload) {
    state.local.isShowBuyerRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowBuyerRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_RECADV_EMIT' (state, payload) {
    state.local.isShowSellerRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowSellerRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_RECADV_EMIT' (state, payload) {
    state.local.isShowNumRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowNumRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_RECEIVING_RECADV_EMIT' (state, payload) {
    state.local.isShowDateReceivingRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDateReceivingRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_RECADV_EMIT' (state, payload) {
    state.local.isShowDateCreationRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDateCreationRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_RECADV_EMIT' (state, payload) {
    state.local.isShowStatusRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowStatusRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_RECADV_EMIT' (state, payload) {
    state.local.isShowServiceRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowServiceRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_INVOICE_RECADV_EMIT' (state, payload) {
    state.local.isShowInvoiceRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowInvoiceRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_RECADV_EMIT' (state, payload) {
    state.local.isShowCentroVendedorRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroVendedorRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_RECADV_EMIT' (state, payload) {
    state.local.isShowCentroCompradorRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroCompradorRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_RECADV_EMIT' (state, payload) {
    state.local.isShowCentroEntregaRecadvEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroEntregaRecadvEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Columnas Tabla Recepciones Recibidas
  'IS_SHOW_BUYER_RECADV_RECEIVED' (state, payload) {
    state.local.isShowBuyerRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowBuyerRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_RECADV_RECEIVED' (state, payload) {
    state.local.isShowSellerRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowSellerRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_RECADV_RECEIVED' (state, payload) {
    state.local.isShowNumRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowNumRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_RECEIVING_RECADV_RECEIVED' (state, payload) {
    state.local.isShowDateReceivingRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDateReceivingRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_RECADV_RECEIVED' (state, payload) {
    state.local.isShowDateCreationRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDateCreationRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_RECADV_RECEIVED' (state, payload) {
    state.local.isShowStatusRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowStatusRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_RECADV_RECEIVED' (state, payload) {
    state.local.isShowServiceRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowServiceRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_INVOICE_RECADV_RECEIVED' (state, payload) {
    state.local.isShowInvoiceRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowInvoiceRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_VENDEDOR_RECADV_RECEIVED' (state, payload) {
    state.local.isShowCentroVendedorRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroVendedorRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_COMPRADOR_RECADV_RECEIVED' (state, payload) {
    state.local.isShowCentroCompradorRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroCompradorRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTRO_ENTREGA_RECADV_RECEIVED' (state, payload) {
    state.local.isShowCentroEntregaRecadvReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCentroEntregaRecadvReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas emitidas
  'IS_SHOW_CODE_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowCodeLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCodeLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_CODE_SELLER_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowItemCodeSellerRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowItemCodeSellerRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_CODE_BUYER_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowItemCodeBuyerRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowItemCodeBuyerRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowDescriptionRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDescriptionRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowOrderLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowOrderLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_NOTE_NUMBER_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowDeliveryNoteNumberRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDeliveryNoteNumberRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_NOTE_LINE_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowDeliveryNoteLineRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDeliveryNoteLineRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESPATCH_QUANTITY_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowDespatchQuantityLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDespatchQuantityLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVED_QUANTITY_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowReceivedQuantityLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowReceivedQuantityLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACCEPTED_QUANTITY_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowAcceptedQuantityLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowAcceptedQuantityLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowMeasureRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowMeasureRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PRICE_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowPriceLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowPriceLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CURRENCY_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowCurrencyRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCurrencyRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowStatusRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowStatusRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SUBTYPE_RECADV_LINES_EMIT' (state, payload) {
    state.local.isShowSubtypeRecadvLinesEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowSubtypeRecadvLinesEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  // Columnas lineas recibidas
  'IS_SHOW_CODE_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowCodeLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCodeLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_CODE_SELLER_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowItemCodeSellerRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowItemCodeSellerRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_CODE_BUYER_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowItemCodeBuyerRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowItemCodeBuyerRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowDescriptionRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDescriptionRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowOrderLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowOrderLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_NOTE_NUMBER_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowDeliveryNoteNumberRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDeliveryNoteNumberRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DELIVERY_NOTE_LINE_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowDeliveryNoteLineRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDeliveryNoteLineRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESPATCH_QUANTITY_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowDespatchQuantityLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowDespatchQuantityLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVED_QUANTITY_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowReceivedQuantityLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowReceivedQuantityLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACCEPTED_QUANTITY_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowAcceptedQuantityLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowAcceptedQuantityLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MEASURE_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowMeasureRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowMeasureRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PRICE_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowPriceLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowPriceLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CURRENCY_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowCurrencyRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowCurrencyRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowStatusRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowStatusRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SUBTYPE_RECADV_LINES_RECEIVED' (state, payload) {
    state.local.isShowSubtypeRecadvLinesReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.recepciones.isShowSubtypeRecadvLinesReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
